<grid [class.rtl]="isRtl"></grid>
